import React from "react";
import useForm from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SuccessMessage } from "./SuccessMessage";
import { PaymentFormView } from "./PaymentFormView";
import { handleProfileSubmit } from "../../redux/modules/profile/actions";
import * as yup from 'yup'

const validationSchema = yup.object().shape({
    cardNumber: yup.number().required().typeError("Введите 16 чисел"),
    date: yup.string().required("Введите дату"),
    cardName: yup.string().required("Введите имя"),
    cvc: yup.number().required().typeError("Введите CVC")
})

export const PaymentForm = () => {
  const dispatch = useDispatch();
  const defaultValues = useSelector(state => state.profile);
  const { register, handleSubmit, errors} = useForm({
    defaultValues: defaultValues || {},
    validationSchema
  });
  const [submitSucceeded, setSubmitSucceeded] = React.useState(false);

  React.useEffect(() => {
    setSubmitSucceeded(false);
  }, []);

  const onSubmit = data => {
    dispatch(handleProfileSubmit(data));
    setSubmitSucceeded(true);
  };

  if (submitSucceeded) {
    return <SuccessMessage />;
  }

  return (
    <PaymentFormView
      handleSubmit={handleSubmit(onSubmit)}
      register={register}
      errors={errors}
    />
  );
};
